/* Copyright (C) 2018 SplendidCRM Software, Inc. All Rights Reserved. 
 * Any use of the contents of this file are subject to the SplendidCRM Professional Source Code License Agreement, or other written agreement between you and SplendidCRM ("License"). 
 * SplendidCRM owns all proprietary rights, including all copyrights, patents, trade secrets, and trademarks, in and to the contents of this file.  You will not link to or in any way 
 * combine the contents of this file or any derivatives with any Open Source Code in any manner that would require the contents of this file to be made available to any third party. 
 */

// 1. React and fabric. 
import * as React from 'react';
// 2. Store and Types. 
// 3. Scripts. 
import Sql              from '../scripts/Sql';
import Security         from '../scripts/Security';
import { FromJsonDate } from '../scripts/Formatting';
// 4. Components and Views. 

interface IDateTimeProps
{
	row     : any;
	layout  : any;
	dateOnly: boolean;
}

class DateTime extends React.PureComponent<IDateTimeProps>
{
	public render()
	{
		const { layout, row, dateOnly } = this.props;
		let DATA_VALUE = '';
		let DATA_FIELD = Sql.ToString(layout.DATA_FIELD);
		if ( dateOnly )
		{
			//console.log((new Date()).toISOString() + ' ' + this.constructor.name + '.Render Date ' + DATA_FIELD, row);
		}
		else
		{
			//console.log((new Date()).toISOString() + ' ' + this.constructor.name + '.Render DateTime ' + DATA_FIELD, row);
		}
		if ( layout == null )
		{
			return (<div>layout prop is null</div>);
		}
		else if ( Sql.IsEmptyString(DATA_FIELD) )
		{
			return (<div>DATA_FIELD is empty for FIELD_INDEX { layout.FIELD_INDEX }</div>);
		}
		else
		{
			let sVALUE = (row ? Sql.ToString(row[DATA_FIELD]) : '');
			if ( row )
			{
				DATA_VALUE = row[DATA_FIELD];
				if ( dateOnly )
				{
					DATA_VALUE = FromJsonDate(DATA_VALUE, Security.USER_DATE_FORMAT());
				}
				else
				{
					DATA_VALUE = FromJsonDate(DATA_VALUE, Security.USER_DATE_FORMAT() + ' ' + Security.USER_TIME_FORMAT());
				}
			}
			return (<div>{ DATA_VALUE }</div>);
		}
	}
}

export default DateTime;
